import { FC, ReactElement, useState } from 'react';

import type { UploadFile } from 'antd';
import { Upload } from 'antd';

import { cvFileTypes } from 'constants/jobseekerSettings';

import { ReactComponent as FileIcon } from 'assets/icons/file.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/trash.svg';
import { ReactComponent as UploadIcon } from 'assets/icons/upload.svg';
import { useTranslation } from 'react-i18next';

interface UploadFileControlProps {
  onChangeFile: (file: UploadFile | null) => void;
  isRoundCorners?: boolean;
  allowedFileTypes?: string;
  label?: string;
}

const UploadFileControl: FC<UploadFileControlProps> = ({
  onChangeFile,
  isRoundCorners,
  allowedFileTypes = cvFileTypes,
  label
}): ReactElement => {
  const { t } = useTranslation()
  
  const { Dragger } = Upload;
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const uploadLable = label ?? t('common.uploadFile.label')

  const handleBeforeUpload = (file: UploadFile): boolean => {
    setFileList([file]);
    onChangeFile(file);
    return false;
  };

  const handleRemove = (): void => {
    setFileList([]);
    onChangeFile(null);
  };

  return (
    <div className="upload-button-container">
      <Dragger
        style={{ borderRadius: isRoundCorners ? '18px' : 0 }}
        fileList={fileList}
        beforeUpload={handleBeforeUpload}
        accept={allowedFileTypes}
        maxCount={1}
        onRemove={handleRemove}
        iconRender={() => <FileIcon />}
        showUploadList={{
          showRemoveIcon: true,
          removeIcon: <TrashIcon className="icon-trash" />
        }}
      >
        <UploadIcon />
        <span>{uploadLable}</span>
      </Dragger>
    </div>
  );
};

export default UploadFileControl;
